module.exports = __webpack_public_path__ + "static/005-b08ac50de1c44e490c9d9ab1eeb038e7.png";